/**
 * Hook for managing QZ Tray printer connection
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useCallback } from 'react';
import axios from 'axios';
// @ts-ignore
import qz from 'qz-tray';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDefaultNetworkPrinterDetail, fetchPrinterList, selectPrinterList, setDefaultNetworkPrinterDetail, selectIsQzConnected, selectQzHostname, selectUserPreferences, setQzConnectionActive, setQzDeviceContext, setUserPreference } from '../../redux/packing';
import { getQzTrayDeviceContext, showQzConnectionWarning } from '../../helper/functions';
export var usePrinterConnection = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var userPreferences = useSelector(selectUserPreferences);
    var printerList = useSelector(selectPrinterList);
    var isConnectionActive = useSelector(selectIsQzConnected);
    var hostname = useSelector(selectQzHostname);
    var _a = useState([]), printers = _a[0], setPrinters = _a[1];
    var setIsConnectionActive = useCallback(function (isActive) {
        dispatch(setQzConnectionActive(isActive));
    }, [dispatch]);
    var resolveQzContext = useCallback(function (showWarning) {
        if (showWarning === void 0) { showWarning = true; }
        return __awaiter(void 0, void 0, Promise, function () {
            var result, defaultPrinterResult, preferences;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getQzTrayDeviceContext(setIsConnectionActive)];
                    case 1:
                        result = _a.sent();
                        dispatch(setQzDeviceContext({
                            connected: result.connected,
                            hostname: result.hostname,
                            isChecked: true
                        }));
                        if (!(!result.connected || !result.hostname)) return [3 /*break*/, 4];
                        if (!showWarning) return [3 /*break*/, 3];
                        return [4 /*yield*/, showQzConnectionWarning(notification, t, function () {
                                return getQzTrayDeviceContext(setIsConnectionActive);
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, { hostname: null, preferences: {} }];
                    case 4: return [4 /*yield*/, dispatch(fetchDefaultNetworkPrinterDetail({ hostname: result.hostname }))];
                    case 5:
                        defaultPrinterResult = _a.sent();
                        preferences = fetchDefaultNetworkPrinterDetail.fulfilled.match(defaultPrinterResult)
                            ? defaultPrinterResult.payload || {}
                            : {};
                        return [2 /*return*/, { hostname: result.hostname, preferences: preferences }];
                }
            });
        });
    }, [dispatch, setIsConnectionActive, t]);
    var refreshQzHostname = useCallback(function (showWarning) {
        if (showWarning === void 0) { showWarning = true; }
        return __awaiter(void 0, void 0, Promise, function () {
            var hostname;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, resolveQzContext(showWarning)];
                    case 1:
                        hostname = (_a.sent()).hostname;
                        return [2 /*return*/, hostname];
                }
            });
        });
    }, [resolveQzContext]);
    // Connect to QZ Tray
    var connectPrinter = useCallback(function (showWarning) {
        if (showWarning === void 0) { showWarning = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var preferences;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, resolveQzContext(showWarning)];
                    case 1:
                        preferences = (_a.sent()).preferences;
                        return [2 /*return*/, preferences];
                }
            });
        });
    }, [resolveQzContext]);
    var resolvePrinterForPrint = useCallback(function (printerType, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, Promise, function () {
            var printerKey, resolvedPreferences;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        printerKey = "qz.printer." + printerType + ".active";
                        if (!(options.refresh || !((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive()))) return [3 /*break*/, 2];
                        return [4 /*yield*/, connectPrinter((_b = options.showWarning) !== null && _b !== void 0 ? _b : true)];
                    case 1:
                        resolvedPreferences = _d.sent();
                        if (!((_c = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _c === void 0 ? void 0 : _c.isActive())) {
                            return [2 /*return*/, undefined];
                        }
                        if (Object.prototype.hasOwnProperty.call(resolvedPreferences, printerKey)) {
                            return [2 /*return*/, resolvedPreferences[printerKey] || undefined];
                        }
                        _d.label = 2;
                    case 2: return [2 /*return*/, userPreferences[printerKey]];
                }
            });
        });
    }, [connectPrinter, userPreferences]);
    // Disconnect from QZ Tray
    var disconnectPrinter = useCallback(function () {
        var _a;
        if (qz && ((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive())) {
            qz.websocket.disconnect();
            setIsConnectionActive(false);
        }
    }, [setIsConnectionActive]);
    // Find available printers
    var findPrinters = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var foundPrinters, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 5, , 6]);
                    if (!!((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive())) return [3 /*break*/, 2];
                    return [4 /*yield*/, connectPrinter()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!((_b = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _b === void 0 ? void 0 : _b.isActive())) return [3 /*break*/, 4];
                    return [4 /*yield*/, qz.printers.find()];
                case 3:
                    foundPrinters = _c.sent();
                    setPrinters(foundPrinters || []);
                    return [2 /*return*/, foundPrinters || []];
                case 4: return [2 /*return*/, []];
                case 5:
                    error_1 = _c.sent();
                    console.error('Error finding printers:', error_1);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [connectPrinter]);
    var refreshPrinterList = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchPrinterList())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    // Print a label
    var printLabel = useCallback(function (labelUrl, printerType, printerNameOverride) {
        if (printerType === void 0) { printerType = 'main'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var printerKey, printerName, config_1, moquiSessionToken, response, blob, reader_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        printerKey = "qz.printer." + printerType + ".active";
                        printerName = printerNameOverride || userPreferences[printerKey];
                        if (!qz || !qz.websocket || !qz.printers || !printerName) {
                            console.error('qz library not initialized or no printer selected');
                            return [2 /*return*/];
                        }
                        if (!!qz.websocket.isActive()) return [3 /*break*/, 2];
                        return [4 /*yield*/, connectPrinter()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!qz.websocket.isActive()) return [3 /*break*/, 4];
                        config_1 = qz.configs.create(printerName);
                        moquiSessionToken = localStorage.getItem('moquiSessionToken');
                        return [4 /*yield*/, axios.get(labelUrl + "&moquiSessionToken=" + moquiSessionToken, {
                                responseType: 'arraybuffer',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/pdf'
                                }
                            })];
                    case 3:
                        response = _a.sent();
                        if (response.status !== 200) {
                            throw new Error("HTTP error! Status: " + response.status);
                        }
                        blob = new Blob([response.data]);
                        reader_1 = new FileReader();
                        reader_1.onloadend = function () {
                            var result = reader_1.result;
                            if (result) {
                                var base64data = result.split(',')[1];
                                var printDataObj = {
                                    type: 'pixel',
                                    format: 'pdf',
                                    flavor: 'base64',
                                    data: base64data
                                };
                                qz.print(config_1, [printDataObj])
                                    .then(function () {
                                    console.log('Successfully printed');
                                })
                                    .catch(function (err) {
                                    console.error('Print error =>', err);
                                });
                            }
                            else {
                                console.error('Reader result is null or undefined');
                            }
                        };
                        reader_1.readAsDataURL(blob);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        console.error('Error printing label:', error_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }, [userPreferences, connectPrinter]);
    // Set active printer
    var setActivePrinter = useCallback(function (printerType, printerName) {
        var preferenceKey = "qz.printer." + printerType + ".active";
        dispatch(setUserPreference({
            preferenceKey: preferenceKey,
            preferenceValue: printerName
        }));
    }, [dispatch]);
    var setDefaultPrinter = useCallback(function (printerType, printerName) { return __awaiter(void 0, void 0, void 0, function () {
        var saveHostname, _a, networkPrinter, printerListResult, resolvedPrinterList, savePrinterResult, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(printerType === 'main')) return [3 /*break*/, 6];
                    _a = hostname;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, resolveQzContext(false)];
                case 1:
                    _a = (_b.sent()).hostname;
                    _b.label = 2;
                case 2:
                    saveHostname = _a;
                    networkPrinter = printerList.find(function (printer) { return printer.value === printerName || printer.key === printerName; });
                    if (!!networkPrinter) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(fetchPrinterList())];
                case 3:
                    printerListResult = _b.sent();
                    resolvedPrinterList = fetchPrinterList.fulfilled.match(printerListResult)
                        ? printerListResult.payload || []
                        : [];
                    networkPrinter = resolvedPrinterList.find(function (printer) { return printer.value === printerName || printer.key === printerName; });
                    _b.label = 4;
                case 4:
                    if (!networkPrinter) {
                        notification.error({
                            message: t('Printer not saved'),
                            description: t('Selected printer was not found in the facility printer list.')
                        });
                        throw new Error('Selected printer was not found in the facility printer list');
                    }
                    return [4 /*yield*/, dispatch(setDefaultNetworkPrinterDetail({
                            networkPrinterId: networkPrinter.key,
                            printerName: networkPrinter.value,
                            hostname: saveHostname
                        }))];
                case 5:
                    savePrinterResult = _b.sent();
                    if (setDefaultNetworkPrinterDetail.rejected.match(savePrinterResult)) {
                        errorMessage = savePrinterResult.payload || 'Failed to set default printer';
                        notification.error({
                            message: t('Printer not saved'),
                            description: errorMessage
                        });
                        throw new Error(errorMessage);
                    }
                    return [2 /*return*/];
                case 6:
                    setActivePrinter(printerType, printerName);
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, hostname, printerList, resolveQzContext, setActivePrinter, t]);
    // Get active printer
    var getActivePrinter = useCallback(function (printerType) {
        var printerKey = "qz.printer." + printerType + ".active";
        return userPreferences[printerKey];
    }, [userPreferences]);
    return {
        isConnectionActive: isConnectionActive,
        hostname: hostname,
        printers: printers,
        connectPrinter: connectPrinter,
        disconnectPrinter: disconnectPrinter,
        findPrinters: findPrinters,
        refreshPrinterList: refreshPrinterList,
        refreshQzHostname: refreshQzHostname,
        resolvePrinterForPrint: resolvePrinterForPrint,
        printLabel: printLabel,
        setActivePrinter: setActivePrinter,
        setDefaultPrinter: setDefaultPrinter,
        getActivePrinter: getActivePrinter
    };
};
export default usePrinterConnection;
